import { render, staticRenderFns } from "./FileTransfer004.vue?vue&type=template&id=2f31cfe4&"
import script from "./FileTransfer004.vue?vue&type=script&lang=js&"
export * from "./FileTransfer004.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports